import React from 'react'
import { Modal, Button } from 'semantic-ui-react'

const ModalActions = (props) => {
  const { detailsModalType, tableData, collectionList, contractType, detailsModal, eventClick, mtdBillable, productionPrice } = props;
  const { eventDate, startDate, details, nextDaysObj, nextDaysData, sendGoxReport, sendCollectionsReport, sendFamilyReport, sendReport, onSelectEvent } = props;

  if (detailsModalType === 'goxDetailsList') {
    return (
      <Modal.Actions>
        <Button primary className="mt20" onClick={() => sendGoxReport(contractType)}>
          Send Report
        </Button>
      </Modal.Actions>
    )
  }

  if (detailsModalType === 'nextDays' || detailsModalType === 'familyCapacityView') {
    if (detailsModalType === 'familyCapacityView') {
      return null
    }

    const hasTableData = tableData && Object.keys(tableData).length

    return (
      <Modal.Actions>
        {hasTableData && (
          <Button
            primary
            onClick={() => sendFamilyReport({
              confirmed: nextDaysObj.confirmed,
              type: nextDaysObj.type,
              startDate: eventDate,
              practice: nextDaysData?.familyPractice
            })}
          >
            Send Report
          </Button>
        )}
      </Modal.Actions>
    )
  }

  const hasData = (tableData && Object.keys(tableData).length) ||
    (collectionList && collectionList.length > 0)

  if (!hasData) {
    return <Modal.Actions />
  }

  const showCollectionButton = detailsModalType === 'collectionList'
  const showPayStubButton = detailsModalType === 'payStub'
  const hideReportButton = detailsModal === 'payStub' || detailsModalType === 'payStub' || detailsModalType === 'goxDetailsList';
  const showDetailsButton = detailsModal === 'report' && !['adjustment', 'writeoff'].includes(detailsModalType)

  return (
    <Modal.Actions>
      {showCollectionButton && (
        <Button
          primary
          className="mt20"
          onClick={() => sendCollectionsReport(contractType)}
        >
          Send Report
        </Button>
      )}

      {!showCollectionButton && !hideReportButton && (
        <Button
          primary
          className="mr10"
          onClick={() => sendReport(detailsModalType, detailsModal, eventClick, mtdBillable, productionPrice, eventDate, startDate)}
        >
          Send Report
        </Button>
      )}

      {showDetailsButton && (
        <Button
          primary
          className="mr-0"
          onClick={() => onSelectEvent({ type: detailsModalType, id: eventDate }, 'details', eventClick)}
        >
          Report Details
        </Button>
      )}

      {showPayStubButton && (
        <Button
          primary
          className="mr10"
          onClick={() => sendReport(detailsModalType, detailsModal, eventClick, mtdBillable, productionPrice, eventDate, startDate, details)}
        >
          Send Report
        </Button>
      )}
    </Modal.Actions>
  )
}

export default ModalActions
